"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var utils_1 = require("../../utils");
var FlashMessages_1 = require("./context/FlashMessages");
var SuccessFlashMessages = function () {
    var _a = react_1.useState(false), started = _a[0], setStarted = _a[1];
    var _b = FlashMessages_1.useFlashMessages(), messages = _b.messages, resetSuccessMessage = _b.resetSuccessMessage;
    react_1.useEffect(function () {
        if (!started && messages.success) {
            setStarted(true);
            utils_1.flash(messages.success, utils_1.AlertType.SUCCESS, function () {
                resetSuccessMessage();
                setStarted(false);
            });
        }
    }, [messages.success]);
    return null;
};
exports.default = SuccessFlashMessages;
//# sourceMappingURL=SuccessFlashMessages.js.map